const addZeroToTime = (value: number) => {
    const stringValue = String(value)
    return stringValue.length === 1 ? `0${stringValue}` : stringValue
}

export default addZeroToTime